import { render, staticRenderFns } from "./Step-2-healthcare.vue?vue&type=template&id=cbab2050&scoped=true&"
import script from "./Step-2-healthcare.vue?vue&type=script&lang=js&"
export * from "./Step-2-healthcare.vue?vue&type=script&lang=js&"
import style0 from "./Step-2-healthcare.vue?vue&type=style&index=0&id=cbab2050&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbab2050",
  null
  
)

export default component.exports